// extracted by mini-css-extract-plugin
export default {"reset":"Reset_reset__wD+iE","reset__popover":"Reset_reset__popover__MVJ5X","reset__text_center":"Reset_reset__text_center__R+x-c"};